import { Button } from "@quark/design";
import { CSSProperties, FC } from "react";
import { Course } from "../../../types";
import { getTargetAudienceLabel } from "../utils";
import ArrowRight from "../../../icons/arrow-right";
import styles from "./index.module.scss";
import LevelIcon from "./level-icon";
import CardImg from "../card-img";
import { useNavigate } from "react-router-dom";

interface CourseCardProps {
  dataSource: Course;
  style?: CSSProperties;
}

const CourseCard: FC<CourseCardProps> = ({ dataSource, style }) => {
  const navigate = useNavigate();

  const goTocoursePage = () => {
    navigate(`/course/${dataSource.course_no}/catalog`);
  };

  return (
    <div className={styles["course-card"]} style={style}>
      <CardImg src={dataSource.cover_img} />
      {dataSource.is_buy && <div className={styles.learning}>上课中</div>}
      <div className={styles.content}>
        <div className={styles.title}>
          <div className={styles["title-text"]}>{dataSource.title}</div>
        </div>
        <div className={styles.summary}>{dataSource.summary}</div>
      </div>
      <div className={styles.footer}>
        <div className={styles.left}>
          <LevelIcon level={dataSource.target_audience} />
          <span className={styles["target-audience-name"]}>
            {getTargetAudienceLabel(dataSource.target_audience)}
          </span>
        </div>
        <Button onClick={() => goTocoursePage()}>
          <span style={{ marginRight: 3 }}>去学习</span>
          <ArrowRight />
        </Button>
      </div>
    </div>
  );
};

export default CourseCard;
